<template>
  <pt-integral-goods-review class="pt-integral-goods-review__page"></pt-integral-goods-review>
</template>

<script>
import PtIntegralGoodsReview from 'cps/integral-mall-manage/pt-goods-of-integral/pt-integral-goods-review/withData'
export default {
  name: 'pt-integral-goods-review__view',
  components: {
    'pt-integral-goods-review': PtIntegralGoodsReview
  }
}
</script>
